const pushToDataLayer = window.BAO.Utils.pushToDataLayer

window.addEventListener('PLP-grid-view-changed', trackPlpGridChange)
window.addEventListener('filter-form-submit', trackFilters)
document.addEventListener('wishlist-item-added', trackAddToWishlist)
document.addEventListener('wishlist-item-removed', trackRemoveFromWishlist)
window.addEventListener('PDP-gallery-click', trackPdpGalleryClick)
window.addEventListener('PDP-gallery-thumbnail-click', trackPdpGalleryThumbClick)
window.addEventListener('pdp-colour-change', trackPDPColourChange)
window.addEventListener('pdp-variant-change', trackVariantChange)
document.addEventListener('add-to-cart-quick-add', trackQuickAdd)
document.addEventListener('add-to-cart', trackAddToCart)

handleNavigationClick()
watchForPDPRecsCarousel()
clearEventContexts()
setupEventListeners()

function clearEventContexts() {
  window.sessionStorage.removeItem('BAO-gtm-event-context--quick-add')
}

function setupEventListeners() {
  const hotspotEls = document.querySelectorAll('[data-gtm-el="hotspot"]')
  hotspotEls.forEach(el => {
    trackHotspotViews(el)
  });

  const productCarouselEls = document.querySelectorAll('[data-gtm-el="product-carousel"]')
  productCarouselEls.forEach(el => {
    trackProductCarouselViews(el)
    el.addEventListener('click', trackProductCarouselClicks)
  });

  const pdpReviewsTrigger = document.querySelector('[data-gtm-el="pdp-reviews-stars"]')
  if (pdpReviewsTrigger) {
    pdpReviewsTrigger.addEventListener('click', () => {
      pushToDataLayer('pdp_reviews_stars_clicked')
    })
  }
}

function trackPlpGridChange(event) {
  const parameters = {
    event_action: event.detail.selectedDisplay
  }

  pushToDataLayer('plp_grid_view', parameters)
}

function trackFilters (event) {
  const target = event.detail.target
  const targetContext = target.closest('[data-gtm-target-context]')?.dataset.gtmTargetContext || 'active facet pill'
  const targetText = target.value || target.closest('[data-gtm-target-text]')?.dataset.gtmTargetText || ''

  const parameters = {
    event_action: target.checked ? 'add' : 'remove',
    target_text: targetText,
    target_context: targetContext,
  }

  pushToDataLayer('filter_click', parameters)
}

function trackAddToWishlist(event) {
  const product = event.detail.product
  const productPrice = isNaN(parseInt(product.price)) ? 0 : parseInt(product.price)

  const parameters = {
    currency: window.Shopify.currency.active,
    value: productPrice,
    items: [
      {
        item_id: product.id,
        item_title: product.title,
        price: productPrice,
      },
    ],
  }

  pushToDataLayer('add_to_wishlist', parameters)
}

function trackRemoveFromWishlist (event) {
  const product = event.detail.product
  const parameters = { item_title: product.title }

  pushToDataLayer('remove_from_wishlist', parameters)
}

function trackPdpGalleryClick (event) {
  const mediaIndex = event.detail?.mediaIndex || ''

  const parameters = {
    target_index: mediaIndex,
  }

  pushToDataLayer('pdp_gallery_click', parameters)
}

function trackPdpGalleryThumbClick (event) {
  const mediaIndex = event.detail?.mediaIndex || ''

  const parameters = {
    target_index: mediaIndex,
  }

  pushToDataLayer('pdp_gallery_thumbnail_click', parameters)
}

function handleNavigationClick () {
  const desktopNavItems = document.querySelectorAll('.link-menu')
  const mobileNavItems = document.querySelectorAll('.fostr-mobilemenu-link-block:not(.country-picker-wrapper) a')

  desktopNavItems.forEach((item) => {
    item.addEventListener('click', trackDesktopNavClick)
  })

  mobileNavItems.forEach((item) => {
    item.addEventListener('click', trackMobileNavClick)
  })
}

function trackDesktopNavClick (event) {
  const target = event.target
  const targetContext = target.closest('[data-gtm-target-context]').dataset.gtmTargetContext

  const parameters = {
    target_context: targetContext.trim(),
    target_text: target.textContent,
    target_url: target.href,
  }

  pushToDataLayer('desktop_navigation_click', parameters)
}

function trackMobileNavClick (event) {
  const target = event.target

  const parameters = {
    target_text: target.textContent,
    target_url: target.href,
  }

  pushToDataLayer('mobile_navigation_click', parameters)
}

function trackPDPColourChange (event) {
  const { colour } = event.detail

  const parameters = {
    target_text: colour,
  }

  pushToDataLayer('pdp_colour_change', parameters)
}

function trackVariantChange (event) {
  const {
    target,
    selectedOptionName,
    selectedOptionValue,
  } = event.detail

  const parameters = {
    target_context: selectedOptionName,
    target_text: selectedOptionValue,
  }

  const isQuickAddModal = target.closest('[data-gtm-el="quick-add-modal"]')

  if (isQuickAddModal) {
    pushToDataLayer('quick_add_variant_change', parameters)
  } else {
    pushToDataLayer('pdp_variant_change', parameters)
  }
}

function trackQuickAdd(event) {
  const eventContext = window.sessionStorage.getItem('BAO-gtm-event-context--quick-add')
  const item = event.detail.items ? event.detail.items[0] : event.detail

  const currency = window.Shopify?.currency.active || ''
  const priceValue = (item.final_price ?? item.price ?? 0) / 100

  const item_obj = {
    product_id: item.product_id,
    variant_id: item.variant_id,
    name: item.product_title,
    brand: item.vendor,
    category: item.product_type,
    price: priceValue,
    quantity: item.quantity,
    variant: item.variant_title || (item.variant_options ? item.variant_options.join(' / ') : '')
  }

  const parameters = {
    item_id: item?.id,
    currency: currency,
    item_obj: item_obj,
    item_title: item?.title,
    item_value: item?.price,
    event_context: eventContext ? eventContext : ''
  }

  pushToDataLayer('add_to_cart_quick_add', parameters)

  if (item['product_type']?.toLowerCase() === 'bundle') {
    const { event_context, ...parametersWithoutContext } = parameters
    pushToDataLayer('quick_add_bundle', parametersWithoutContext)
  }

  if (eventContext === 'hotspot') {
    const { event_context, ...parametersWithoutContext } = parameters
    pushToDataLayer('quick_add_hotspot', parametersWithoutContext)
  }

  if (eventContext === 'more-in-print-carousel') {
    const { event_context, ...parametersWithoutContext } = parameters
    pushToDataLayer('quick_add_more_in_print', parametersWithoutContext)
  }

  if (eventContext) {
    window.sessionStorage.removeItem('BAO-gtm-event-context--quick-add')
  }
}

function trackAddToCart(event) {
  const { item, form } = event.detail

  if (!item) {
    console.error("trackAddToCart: No item details found. Cannot push to dataLayer.");
    return;
  }

  const targetContext = form?.dataset?.gtmTargetContext || ''
  const currency = window.Shopify?.currency.active || ''
  const priceValue = (item.final_price ?? item.price ?? 0) / 100

  const item_obj = {
    product_id: item.product_id,
    variant_id: item.variant_id,
    name: item.product_title,
    brand: item.vendor,
    category: item.product_type,
    price: priceValue,
    quantity: item.quantity,
    variant: item.variant_title || (item.variant_options ? item.variant_options.join(' / ') : '')
  }

  const parameters = {
    item_id: item?.id,
    item_title: item?.title,
    item_value: item?.price,
    target_context: targetContext,
    currency,
    item_obj,
  }

  pushToDataLayer('add_to_cart_form', parameters)

  if (item['product_type']?.toLowerCase() === 'bundle' && !targetContext.includes('quick-buy')) {
    pushToDataLayer('add_to_cart_bundle', parameters)
  }
}

function trackHotspotViews(targetElement) {
  const observer = new IntersectionObserver((entries) => {
    // eslint-disable-next-line shopify/prefer-early-return
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        window.dataLayer.push({
          event: 'hotspot_viewed',
          target_context: targetElement.getAttribute('data-gtm-target-context') || 'unknown',
        });

        observer.unobserve(entry.target);
      }
    });
  }, {threshold: 0});

  observer.observe(targetElement);
  return observer;
}

function watchForPDPRecsCarousel() {
  const selector = '[data-gtm-target-context="you-may-also-like"]'
  const existingElement = document.querySelector(selector)

  if (existingElement) return

  // Observe future DOM changes
  const carouselObserver = new MutationObserver((mutations, observer) => {
    const el = document.querySelector(selector)

    if (el) {
      trackProductCarouselViews(el)
      el.addEventListener('click', trackProductCarouselClicks)
      observer.disconnect()
    }
  });

  carouselObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function trackProductCarouselViews(targetElement) {
  const observer = new IntersectionObserver((entries) => {
    // eslint-disable-next-line shopify/prefer-early-return
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const targetContext = targetElement.getAttribute('data-gtm-target-context')

        if (!targetContext.length > 0) return

        pushToDataLayer('product_carousel_viewed', {
          target_context: targetContext
        })

        observer.unobserve(entry.target);
      }
    });
  }, {threshold: 0});

  observer.observe(targetElement);
  return observer;
}

function trackProductCarouselClicks(event) {
  const target = event.target
  const targetProductCard = target.closest('product-card')
  const targetQuickAdd = target.closest('quick-add-opener')

  if (!targetProductCard) return

  const targetContextEl = target.closest('[data-gtm-target-context]')
  const targetContext = targetContextEl.getAttribute('data-gtm-target-context')

  if (!targetQuickAdd) {
    pushToDataLayer('product_carousel_card_clicked', {
      target_context: targetContext
    })
  }

  if (targetQuickAdd) {
    window.sessionStorage.setItem('BAO-gtm-event-context--quick-add', targetContext)
  }
}
